import CalendarItemNotificationPayload from 'owa-service/lib/contract/CalendarItemNotificationPayload';
import { createAppContext } from 'mini-app-context';
import { getCalendarInfoStore } from '../../store/store';
import { trace } from 'owa-trace';

/**
 * Log the notification info on the console
 */
export default function traceNotificationData(
    notification: CalendarItemNotificationPayload,
    incoming: boolean
) {
    const itemId =
        notification.Item && notification.Item.ItemId ? notification.Item.ItemId.Id : '<null>';
    const instanceKey =
        notification.Item && notification.Item.InstanceKey
            ? notification.Item.InstanceKey
            : '<null>';
    const uid = notification.Item && notification.Item.UID ? notification.Item.UID : '<null>';
    let prefix;
    if (incoming) {
        prefix = 'Got calendar notification';
        const ctx = createAppContext();
        const calendar = getCalendarInfoStore().getCalendarInfo(notification.FolderId);
        ctx?.signal('SSE', {
            notificationType: notification.EventType,
            isPeopleCalendar: calendar?.isPeopleCalendar,
            isFolderIdValid: calendar?.isFolderIDValid,
        });
    } else {
        prefix = 'Now Processing calendar notification';
    }
    trace.info(`[CalendarNotifications] '${new Date(Date.now()).toString()}: ${prefix}':
        Type: '${notification.EventType}',
        FolderId: '${notification.FolderId}',
        ItemId: '${itemId}',
        InstanceKey: '${instanceKey}',
        UID: '${uid}'`);
}
